export const pointEarnData = [
  // {
  //   id: 1,
  //   EmpCode: "EMP001",
  //   FullName: "Farah Goh",
  //   EarnedPoints: 68
  // },
  // {
  //   id: 2,
  //   EmpCode: "EMP002",
  //   FullName: "Hui Kaur",
  //   EarnedPoints: 110
  // },
  // {
  //   id: 3,
  //   EmpCode: "EMP003",
  //   FullName: "John Rahman",
  //   EarnedPoints: 254
  // },
  // {
  //   id: 4,
  //   EmpCode: "EMP004",
  //   FullName: "Hui Goh",
  //   EarnedPoints: 202
  // },
  // {
  //   id: 5,
  //   EmpCode: "EMP005",
  //   FullName: "John Hassan",
  //   EarnedPoints: 59
  // },
  // {
  //   id: 6,
  //   EmpCode: "EMP006",
  //   FullName: "Siti Goh",
  //   EarnedPoints: 181
  // },
  // {
  //   id: 7,
  //   EmpCode: "EMP007",
  //   FullName: "Farah Yusof",
  //   EarnedPoints: 65
  // },
  // {
  //   id: 8,
  //   EmpCode: "EMP008",
  //   FullName: "Hui Nurhaliza",
  //   EarnedPoints: 186
  // },
  // {
  //   id: 9,
  //   EmpCode: "EMP009",
  //   FullName: "Siti Nurhaliza",
  //   EarnedPoints: 190
  // },
  // {
  //   id: 10,
  //   EmpCode: "EMP010",
  //   FullName: "Siti Ismail",
  //   EarnedPoints: 91
  // }
];

export const employeeList = [
  // {
  //   id: 1,
  //   type: "reward",
  //   mission: "Team Collaboration Challenge",
  //   points: 50,
  //   remarks: "Great teamwork effort",
  //   missionCompletedDate: "2025-08-01"
  // },
  // {
  //   id: 2,
  //   type: "bonus",
  //   mission: "Customer Feedback Collection",
  //   points: 30,
  //   remarks: "Collected 10 positive reviews",
  //   missionCompletedDate: "2025-08-03"
  // },
  // {
  //   id: 3,
  //   type: "achievement",
  //   mission: "Sales Target Reached",
  //   points: 100,
  //   remarks: "Exceeded monthly quota",
  //   missionCompletedDate: "2025-08-07"
  // },
  // {
  //   id: 4,
  //   type: "reward",
  //   mission: "Knowledge Sharing Session",
  //   points: 40,
  //   remarks: "Conducted internal training",
  //   missionCompletedDate: "2025-08-10"
  // },
  // {
  //   id: 5,
  //   type: "mission",
  //   mission: "Process Improvement Suggestion",
  //   points: 25,
  //   remarks: "Implemented efficiency idea",
  //   missionCompletedDate: "2025-08-12"
  // },
  // {
  //   id: 6,
  //   type: "bonus",
  //   mission: "On-time Project Delivery",
  //   points: 80,
  //   remarks: "Completed ahead of schedule",
  //   missionCompletedDate: "2025-08-14"
  // }
]

